<template>
  <div class="mobile-wrapper">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt" :style="getStyle()">
        <div class="row">
          <div class="col-12 banner-title">
            <i class="material-icons md-36" @click="goBack">keyboard_arrow_left</i>
            <span class="title-text" @click="goBack">Order History</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-white vform position-relative">
      <div class="justify-content-center">
        <div class="col-12 bg-white py-4">
          <div class="container mt-4 pt-4">
            <div v-for="(order, index) in pageOrders" :key="index" class="row">
              <div class="col-sm-12 order-items" :disabled="IsStoreClose">
                <div class="order-item-details">
                  <div class="col-md-12">
                    <div class="row">
                      <h3 class="col-md-9 store-name" style="cursor:pointer;">{{order.StoreName}}</h3>
                      <span class="col-md-3 history-date">{{getCreateDate(order)}}</span>
                    </div>
                    <span class="row order-price">
                      <span>{{ (order.TotalExcludingTax + order.TotalTax) | formatMoney }}</span>
                    </span>
                  </div>
                </div>
                <div class="order-item-cost row">
                  <div class="col-md-7">
                    <button
                      type="button"
                      class="btn btn-primary"
                      :style="mobileStyles.btn"
                      @click="showReorderConfirm(order)"
                    >Reorder</button>
                  </div>
                  <div
                    class="col-md-5"
                    style="margin-left: -10px;"
                  >{{(order.OrderNumber?'#':'')}}{{order.OrderNumber}}</div>
                </div>
              </div>
              <div class="col-sm-12">
                <hr />
              </div>
            </div>
            <div v-if="pageOrders.length == 0">
              <message message="No order available" />
            </div>
          </div>
          <div class="text-center">
            <button
              v-if="orders.length != pageOrders.length"
              class="btn btn-info"
              :style="mobileStyles.btn"
              @click="moreCallback()"
            >More</button>
          </div>
        </div>
      </div>
    </div>
    <confirm
      v-if="showConfirm"
      ref="reorderConfirm"
      :modal-title="'Delete Card'"
      :proccessing="reordering"
      @confirmed="reorder"
      @close="closeConfirm"
    >
      <template slot="body">
        <p>Are you sure you want to reorder current order ?</p>
      </template>
    </confirm>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import shared from "../../sharedscripts/user/OrderHistory.js";
import Message from "./../shared/Message";
import moment from "moment";
import confirm from "../confirm.vue";
export default {
  components: {
    Message,
    confirm
  },

  data() {
    return {
      page: 2,
      perPage: 3,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev"
        }
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false,
      showConfirm: false,
      reordering: false,
      selectedOrder: {}
    };
  },
  computed: {
    ...mapGetters(["user", "currentstore", "mobileStyles", "currentStoreDoc"]),
    ...shared.computed
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    }
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "store",
        params: { storeid: this.currentstore }
      });
    },
    getCreateDate(order) {
      if (order.ScheduledTime)
        return moment(order.ScheduledTime.toDate()).format("lll");
    },
    getStyle() {
      var styles = [];
      styles.push(this.mobileStyles.primaryBackgroundColour);
      return styles;
    },
    ...shared.methods
  }
};
</script>

